<template>
  <div class="layout-component">
    <side-bar ref="sidebar" v-if="!$route.meta.loginPage"></side-bar>
    <!-- notifications -->
    <template v-if="!$route.meta.loginPage" v-for="notification in userNotifications">
      <account-message :key="notification.uuid" :object="notification"></account-message>
    </template>
    <div class="container-fluid">
      <router-view></router-view>
    </div>
    <footer class="footer" v-if="!$route.meta.loginPage">
      <strong>Copyright &copy; {{ new Date().getFullYear() }} <a href="http://www.greensharecar.com.au">GreenShareCar</a>.</strong> All rights
      reserved.
    </footer>
  </div>
</template>

<script>
import AccountMessage from '@/components/displays/AccountMessage.vue'
import SideBar from '@/components/admin/SideBar.vue'
import { mapGetters } from 'vuex'
import { LOAD_ORGANIZATION, LOAD_NOTIFICATIONS } from '@/vuex/types'
import dom from '@/util/dom'

export default {
  name: 'Layout',
  components: {
    AccountMessage,
    SideBar
  },
  computed: {
    ...mapGetters([
      'isLoggedIn',
      'organization',
      'userNotifications'
    ])
  },
  async beforeRouteUpdate (to, from, next) {
    await this.$store.dispatch(LOAD_ORGANIZATION, window.location.hostname)
    if (this.isLoggedIn) {
      await this.$store.dispatch(LOAD_NOTIFICATIONS)
    }
    if (this.organization.stylesheet) {
      this.loadStyles(this.organization.stylesheet)
    }
    next()
  },
  async mounted () {
    await this.$store.dispatch(LOAD_ORGANIZATION, window.location.hostname)
    if (this.organization.stylesheet) {
      this.loadStyles(this.organization.stylesheet)
    }
  },
  methods: {
    loadStyles (stylesheet) {
      let style = document.createElement('link')
      style.rel = 'stylesheet'
      style.href = '/css/' + stylesheet.replace('scss', 'css')
      let head = document.head || document.getElementsByTagName('head')[0]
      head.appendChild(style)
    },
    toggleSidebar () {
      if (dom(this.$root.$el.parentElement).hasClass('sidebar-collapse')) {
        dom(this.$root.$el.parentElement).addClass('sidebar-open').removeClass('sidebar-collapse')
      } else {
        this.closeSidebar()
      }
    },
    closeSidebar () {
      if (document.body.clientWidth < 768) {
        dom(this.$root.$el.parentElement).removeClass('sidebar-open').addClass('sidebar-collapse')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Layout.vue